module.exports = __webpack_public_path__ + "img/gyant_xl_dark_brown_ba_list.1191bc83.jpg";